import { render, staticRenderFns } from "./EditSets.vue?vue&type=template&id=22622652&scoped=true"
import script from "./EditSets.vue?vue&type=script&lang=js"
export * from "./EditSets.vue?vue&type=script&lang=js"
import style0 from "./EditSets.vue?vue&type=style&index=0&id=22622652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22622652",
  null
  
)

export default component.exports